/**
 * True means always
 * false means never
 * undefined means optional
 * any other type is used as a value
 */
const options = {
	newline: '\n',
	separator: '\\',
	dateFormat: 'ddMMyyyy',
	timeFormat: 'HHmm',
	lang: 'nl',
	end: '',
	nnInA2: true,
	trailing: true,
};

export default options;
